// removed by extract-text-webpack-plugin
module.exports = {"title":"c-GroupTitle__title","accent":"c-GroupTitle__accent","big":"c-GroupTitle__big"};


//////////////////
// WEBPACK FOOTER
// ./src/components/presentational/GroupTitle/GroupTitle.scss
// module id = 859
// module chunks = 0